import React from "react";
import { Key } from "@react-types/shared";
import clsx from "clsx";

import Heading from "../heading";
import Search from "../search";
import { THEMES } from "../../theme";

import styles from "./page-header.module.css";

interface PageHeaderProps {
  title: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  search?: {
    isDisabled?: boolean;
    label: string;
    placeholder: string;
    value: string;
    onChange: (key: Key) => void;
  };
}

function PageHeader({ title, actions, search, children }: PageHeaderProps) {
  let searchInput;
  if (search) {
    searchInput = (
      <Search
        isDisabled={search.isDisabled || false}
        value={search.value}
        autofocus={true}
        onChange={search.onChange}
        onClear={search.onChange}
        label={search.label}
        placeholder={search.placeholder}
      />
    );
  }
  return (
    <header
      data-testid="pallet-page-header"
      className={clsx(styles.header, THEMES.blue)}
    >
      <div className={styles.title}>
        <Heading text={title} level="1"></Heading>
      </div>
      {children}
      <div className={styles.pageActions}>
        {searchInput}
        <div className={styles.actions}>{actions}</div>
      </div>
    </header>
  );
}

export default PageHeader;
